<p-dialog
  #dialogRef
  [(visible)]="visible"
  [header]="header"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="dismissableMask"
  [style]="{'width': width}"
  [styleClass]="styleClass"
  [closable]="closable"
  (onHide)="close()"
  [@modalAnimation]
  *appDeviceType="'desktop'"
>
  <router-outlet></router-outlet>
  <ng-content></ng-content>
</p-dialog>

<p-dialog
  #dialogRef
  [(visible)]="visible"
  [header]="header"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="dismissableMask"
  [style]="{'width': '100%'}"
  [styleClass]="'bottom-sheet ' + (styleClass || '')"
  [closable]="closable"
  (onHide)="close()"
  [@modalAnimation]
  position="bottom"
  *appDeviceType="'mobile'"
>
  <router-outlet></router-outlet>
  <ng-content></ng-content>
</p-dialog>

